import { GetterTree } from 'vuex'
import { FeatureFlagModuleState } from './feature-flags.model'

export enum GetterTypes {
  GET_FLAGS = 'GET_FLAGS',
  GET_FLAG_BY_NAME = 'GET_FLAG_BY_NAME'
}

export const getters: GetterTree<FeatureFlagModuleState, unknown> = {
  [GetterTypes.GET_FLAGS](state) {
    return state.flags
  },
  [GetterTypes.GET_FLAG_BY_NAME](state): (a: string) => boolean {
    return (name: string): boolean => {
      if (state.flags && state.flags[name]) return state.flags[name]
      return false
    }
  }
}
